import { render, staticRenderFns } from "./russian-general.vue?vue&type=template&id=b5f9489e&scoped=true&"
import script from "./russian-general.vue?vue&type=script&lang=js&"
export * from "./russian-general.vue?vue&type=script&lang=js&"
import style0 from "./russian-general.vue?vue&type=style&index=0&id=b5f9489e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f9489e",
  null
  
)

export default component.exports